import { DatePipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-campaign-websocket-window',
  templateUrl: './campaign-websocket-window.component.html',
  styleUrls: ['./campaign-websocket-window.component.scss'],
  imports: [NgIf, DatePipe]
})
export class CampaignWebsocketWindowComponent {
  public results;

  constructor() {}
}
